/*
 * File: /src/stores/shop-products-edit.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Friday, 20th July 2018 2:20:53 pm
 * Last Modified: Friday, 10th August 2018 12:29:26 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */
import { StoreDefaultMetafieldsHelper } from '@/helpers'

const initialState = () => ({
    scope: 'articles'
})

const state = StoreDefaultMetafieldsHelper.buildState({ 
    state: initialState()
})


const actions = StoreDefaultMetafieldsHelper.buildActions({
    actions: {}
})

const mutations = StoreDefaultMetafieldsHelper.buildMutations({
    mutations: {}
})

const getters = StoreDefaultMetafieldsHelper.buildGetters({
    getters: {}
})

export default {
    namespaced: true,
    state, actions, mutations, getters
}


// WEBPACK FOOTER //
// ./src/stores/shop-articles-edit.js